import { ContentBlockDto } from '../content-block.dto';

export class ContentBlockParagraph {
    readonly text: string;
    readonly type = 'paragraph';

    constructor({ data }: ContentBlockDto) {
        this.text = data.text;
    }
}
